






import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class muLoading extends Vue {
  @Prop() isShow: boolean;
  @Prop() styleLoading: any;
  @Prop() text: string;
}
